import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Field from '../FlightsManager/MobileFields/Field';
import { FieldType, RoomsProps, TripType } from '../../models';
import { ConnectedRoomSelector } from './RoomSelector';
import { ConnectedRoomSelectorFragment } from '../FlightsManager/MobileFragments';
import { ABUtils } from '../../utils';
import { usePaxSummaryText } from './usePaxSummaryText';
import { getTripType } from '../../redux/currentSearch/selectors';

const RoomSelectorMobileInner = ({ value, hasError, pax, hasNonPrimeHotelKidsErrors }) => {
    const { t } = useTranslation();
    const tripType = useSelector((state) => getTripType(state));
    const isRoundTrip = tripType === TripType.ROUND_TRIP;
    const { isCssVariation } = ABUtils.getABs();

    const [paxSummaryText] = usePaxSummaryText(pax, value.length);
    const errorMessage = hasError || hasNonPrimeHotelKidsErrors ? t('roomSelector.children.error') : null;
    const placeHolder = isCssVariation && !isRoundTrip ? t('flightsManager.selection.pax.title') : '';

    return (
        <>
            <Field
                icon="pax"
                id={FieldType.ROOM}
                value={paxSummaryText}
                errorMessage={errorMessage}
                placeholder={placeHolder}
            />
            <ConnectedRoomSelectorFragment />
        </>
    );
};

RoomSelectorMobileInner.propTypes = {
    value: RoomsProps.isRequired,
    hasError: PropTypes.bool.isRequired,
    hasNonPrimeHotelKidsErrors: PropTypes.bool.isRequired,
    pax: PropTypes.object.isRequired,
};

export const RoomSelector = () => (
    <ConnectedRoomSelector
        render={({ dynamicValue, hasError, dynamicPax, hasNonPrimeHotelKidsErrors, nonPrimeHotelRoomsPax }) => (
            <RoomSelectorMobileInner
                value={dynamicValue}
                hasError={hasError}
                pax={dynamicPax}
                nonPrimeHotelRoomsPax={nonPrimeHotelRoomsPax}
                hasNonPrimeHotelKidsErrors={hasNonPrimeHotelKidsErrors}
            />
        )}
    />
);
